import React from 'react';
import Modal from '../../components/Modals/Modal';
import WarningIcon from '../../components/Icons/outline/WarningIcon';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import RedButton from '../../components/Buttons/RedButton';
import { COLORS } from '../../config';

function DeleteScanModal({
  showDeleteScanModal,
  setShowDeleteScanModal,
  onDelete,
  forceDelete
}) {

  const handleHide = () => {
    setShowDeleteScanModal(false)
  }

  const handleDelete = () => {
    onDelete();
    setShowDeleteScanModal(false);
  }
  
  return (
    <Modal className='min-w-1/2' title={'Warning'} show={showDeleteScanModal} hide={handleHide}>
      <div className='flex flex-col justify-between my-8'>
        <WarningIcon className='h-12 w-12 self-center mb-4 -mt-4' stroke={ COLORS.deleteRed } />
        <>
          <p className='mb-4 text-center'>
            <strong>PROCEED WITH CAUTION.</strong>
          </p>
          <p className='mb-4'>
            You are about to complete erase this Scan from the database.
          </p>
          <p>
            All of the Scan's associated information will be erased completely, and will not be retrievable. Are you sure you want to proceed?
          </p>
        </>
      </div>
      <div className='grid grid-cols-2 gap-x-2'>
        <SecondaryButton onClick={handleHide} text='Cancel'/>
        <RedButton text={forceDelete ? 'Erase Scan' : 'Delete Scan'} onClick={handleDelete} />
      </div>
    </Modal>
  )
}

export default DeleteScanModal;
